/* tslint:disable */
const EXAMPLE_COMPONENTS = {
    "alerts-overview": {
        "packagePath": "mosaic/alerts/alerts-overview",
        "title": "Alerts",
        "componentName": "AlertsOverviewExample",
        "files": [
            "alerts-overview-example.ts",
            "alerts-overview-example.html",
            "alerts-overview-example.css"
        ],
        "selector": "alerts-overview-example",
        "additionalComponents": [],
        "primaryFile": "alerts-overview-example.ts",
        "module": {
            "name": "AlertsExamplesModule",
            "importSpecifier": "mosaic/alerts",
            "importPath": "ptsecurity-mosaic-examples-mosaic-alerts"
        }
    },
    "autocomplete-overview": {
        "packagePath": "mosaic/autocomplete/autocomplete-overview",
        "title": "Basic Input",
        "componentName": "AutocompleteOverviewExample",
        "files": [
            "autocomplete-overview-example.ts",
            "autocomplete-overview-example.html",
            "autocomplete-overview-example.css"
        ],
        "selector": "autocomplete-overview-example",
        "additionalComponents": [],
        "primaryFile": "autocomplete-overview-example.ts",
        "module": {
            "name": "AutocompleteExamplesModule",
            "importSpecifier": "mosaic/autocomplete",
            "importPath": "ptsecurity-mosaic-examples-mosaic-autocomplete"
        }
    },
    "badges-overview": {
        "packagePath": "mosaic/badges/badges-overview",
        "title": "Badges",
        "componentName": "BadgesOverviewExample",
        "files": [
            "badges-overview-example.ts",
            "badges-overview-example.html",
            "badges-overview-example.css"
        ],
        "selector": "badges-overview-example",
        "additionalComponents": [],
        "primaryFile": "badges-overview-example.ts",
        "module": {
            "name": "BadgesExamplesModule",
            "importSpecifier": "mosaic/badges",
            "importPath": "ptsecurity-mosaic-examples-mosaic-badges"
        }
    },
    "button-toggle-multiple-overview": {
        "packagePath": "mosaic/button-toggle/button-toggle-multiple-overview",
        "title": "Basic button-toggle",
        "componentName": "ButtonToggleMultipleOverviewExample",
        "files": [
            "button-toggle-multiple-overview-example.ts",
            "button-toggle-multiple-overview-example.html",
            "button-toggle-multiple-overview-example.css"
        ],
        "selector": "button-toggle-multiple-overview-example",
        "additionalComponents": [],
        "primaryFile": "button-toggle-multiple-overview-example.ts",
        "module": {
            "name": "ButtonToggleExamplesModule",
            "importSpecifier": "mosaic/button-toggle",
            "importPath": "ptsecurity-mosaic-examples-mosaic-button-toggle"
        }
    },
    "button-toggle-overview": {
        "packagePath": "mosaic/button-toggle/button-toggle-overview",
        "title": "button-toggle",
        "componentName": "ButtonToggleOverviewExample",
        "files": [
            "button-toggle-overview-example.ts",
            "button-toggle-overview-example.html",
            "button-toggle-overview-example.css"
        ],
        "selector": "button-toggle-overview-example",
        "additionalComponents": [],
        "primaryFile": "button-toggle-overview-example.ts",
        "module": {
            "name": "ButtonToggleExamplesModule",
            "importSpecifier": "mosaic/button-toggle",
            "importPath": "ptsecurity-mosaic-examples-mosaic-button-toggle"
        }
    },
    "button-colors": {
        "packagePath": "mosaic/button/button-colors",
        "title": "Button's colors",
        "componentName": "ButtonColorsExample",
        "files": [
            "button-colors-example.ts",
            "button-colors-example.html",
            "button-colors-example.css"
        ],
        "selector": "button-colors-example",
        "additionalComponents": [],
        "primaryFile": "button-colors-example.ts",
        "module": {
            "name": "ButtonExamplesModule",
            "importSpecifier": "mosaic/button",
            "importPath": "ptsecurity-mosaic-examples-mosaic-button"
        }
    },
    "button-icon": {
        "packagePath": "mosaic/button/button-icon",
        "title": "Icon button",
        "componentName": "ButtonIconExample",
        "files": [
            "button-icon-example.ts",
            "button-icon-example.html",
            "button-icon-example.css"
        ],
        "selector": "button-icon-example",
        "additionalComponents": [],
        "primaryFile": "button-icon-example.ts",
        "module": {
            "name": "ButtonExamplesModule",
            "importSpecifier": "mosaic/button",
            "importPath": "ptsecurity-mosaic-examples-mosaic-button"
        }
    },
    "button-overview": {
        "packagePath": "mosaic/button/button-overview",
        "title": "Basic button",
        "componentName": "ButtonOverviewExample",
        "files": [
            "button-overview-example.ts",
            "button-overview-example.html",
            "button-overview-example.css"
        ],
        "selector": "button-overview-example",
        "additionalComponents": [],
        "primaryFile": "button-overview-example.ts",
        "module": {
            "name": "ButtonExamplesModule",
            "importSpecifier": "mosaic/button",
            "importPath": "ptsecurity-mosaic-examples-mosaic-button"
        }
    },
    "button-progress": {
        "packagePath": "mosaic/button/button-progress",
        "title": "Progress button",
        "componentName": "ButtonProgressExample",
        "files": [
            "button-progress-example.ts",
            "button-progress-example.html",
            "button-progress-example.css"
        ],
        "selector": "button-progress-example",
        "additionalComponents": [],
        "primaryFile": "button-progress-example.ts",
        "module": {
            "name": "ButtonExamplesModule",
            "importSpecifier": "mosaic/button",
            "importPath": "ptsecurity-mosaic-examples-mosaic-button"
        }
    },
    "card-overview": {
        "packagePath": "mosaic/card/card-overview",
        "title": "Basic Card",
        "componentName": "CardOverviewExample",
        "files": [
            "card-overview-example.ts",
            "card-overview-example.html",
            "card-overview-example.css"
        ],
        "selector": "card-overview-example",
        "additionalComponents": [],
        "primaryFile": "card-overview-example.ts",
        "module": {
            "name": "CardExamplesModule",
            "importSpecifier": "mosaic/card",
            "importPath": "ptsecurity-mosaic-examples-mosaic-card"
        }
    },
    "checkbox-indeterminate": {
        "packagePath": "mosaic/checkbox/checkbox-indeterminate",
        "title": "Indeterminate checkbox",
        "componentName": "CheckboxIndeterminateExample",
        "files": [
            "checkbox-indeterminate-example.ts",
            "checkbox-indeterminate-example.html",
            "checkbox-indeterminate-example.css"
        ],
        "selector": "checkbox-indeterminate-example",
        "additionalComponents": [],
        "primaryFile": "checkbox-indeterminate-example.ts",
        "module": {
            "name": "CheckboxExamplesModule",
            "importSpecifier": "mosaic/checkbox",
            "importPath": "ptsecurity-mosaic-examples-mosaic-checkbox"
        }
    },
    "checkbox-overview": {
        "packagePath": "mosaic/checkbox/checkbox-overview",
        "title": "Basic checkboxes",
        "componentName": "CheckboxOverviewExample",
        "files": [
            "checkbox-overview-example.ts",
            "checkbox-overview-example.html",
            "checkbox-overview-example.css"
        ],
        "selector": "checkbox-overview-example",
        "additionalComponents": [],
        "primaryFile": "checkbox-overview-example.ts",
        "module": {
            "name": "CheckboxExamplesModule",
            "importSpecifier": "mosaic/checkbox",
            "importPath": "ptsecurity-mosaic-examples-mosaic-checkbox"
        }
    },
    "pseudo-checkbox": {
        "packagePath": "mosaic/checkbox/pseudo-checkbox",
        "title": "Pseudo checkbox",
        "componentName": "PseudoCheckboxExample",
        "files": [
            "pseudo-checkbox-example.ts",
            "pseudo-checkbox-example.html",
            "pseudo-checkbox-example.css"
        ],
        "selector": "pseudo-checkbox-example",
        "additionalComponents": [],
        "primaryFile": "pseudo-checkbox-example.ts",
        "module": {
            "name": "CheckboxExamplesModule",
            "importSpecifier": "mosaic/checkbox",
            "importPath": "ptsecurity-mosaic-examples-mosaic-checkbox"
        }
    },
    "absolute-date-formatter": {
        "packagePath": "mosaic/date-formatter/absolute-date-formatter",
        "title": "Basic progress absolute-date-formatter",
        "componentName": "AbsoluteDateFormatterExample",
        "files": [
            "absolute-date-formatter-example.ts",
            "absolute-date-formatter-example.html",
            "absolute-date-formatter-example.css"
        ],
        "selector": "absolute-date-formatter-example",
        "additionalComponents": [],
        "primaryFile": "absolute-date-formatter-example.ts",
        "module": {
            "name": "DateFormatterExamplesModule",
            "importSpecifier": "mosaic/date-formatter",
            "importPath": "ptsecurity-mosaic-examples-mosaic-date-formatter"
        }
    },
    "range-date-formatter": {
        "packagePath": "mosaic/date-formatter/range-date-formatter",
        "title": "Basic progress range-date-formatter",
        "componentName": "RangeDateFormatterExample",
        "files": [
            "range-date-formatter-example.ts",
            "range-date-formatter-example.html",
            "range-date-formatter-example.css"
        ],
        "selector": "range-date-formatter-example",
        "additionalComponents": [],
        "primaryFile": "range-date-formatter-example.ts",
        "module": {
            "name": "DateFormatterExamplesModule",
            "importSpecifier": "mosaic/date-formatter",
            "importPath": "ptsecurity-mosaic-examples-mosaic-date-formatter"
        }
    },
    "relative-date-formatter": {
        "packagePath": "mosaic/date-formatter/relative-date-formatter",
        "title": "Basic progress relative-date-formatter",
        "componentName": "RelativeDateFormatterExample",
        "files": [
            "relative-date-formatter-example.ts",
            "relative-date-formatter-example.html",
            "relative-date-formatter-example.css"
        ],
        "selector": "relative-date-formatter-example",
        "additionalComponents": [],
        "primaryFile": "relative-date-formatter-example.ts",
        "module": {
            "name": "DateFormatterExamplesModule",
            "importSpecifier": "mosaic/date-formatter",
            "importPath": "ptsecurity-mosaic-examples-mosaic-date-formatter"
        }
    },
    "datepicker-language": {
        "packagePath": "mosaic/datepicker/datepicker-language",
        "title": "Multy language datepicker",
        "componentName": "DatepickerLanguageExample",
        "files": [
            "datepicker-language-example.ts",
            "datepicker-language-example.html",
            "datepicker-language-example.css"
        ],
        "selector": "datepicker-language-example",
        "additionalComponents": [],
        "primaryFile": "datepicker-language-example.ts",
        "module": {
            "name": "DatepickerExamplesModule",
            "importSpecifier": "mosaic/datepicker",
            "importPath": "ptsecurity-mosaic-examples-mosaic-datepicker"
        }
    },
    "datepicker-not-empty": {
        "packagePath": "mosaic/datepicker/datepicker-not-empty",
        "title": "Datepicker",
        "componentName": "DatepickerNotEmptyExample",
        "files": [
            "datepicker-not-empty-example.ts",
            "datepicker-not-empty-example.html",
            "datepicker-not-empty-example.css"
        ],
        "selector": "datepicker-not-empty-example",
        "additionalComponents": [],
        "primaryFile": "datepicker-not-empty-example.ts",
        "module": {
            "name": "DatepickerExamplesModule",
            "importSpecifier": "mosaic/datepicker",
            "importPath": "ptsecurity-mosaic-examples-mosaic-datepicker"
        }
    },
    "datepicker-overview": {
        "packagePath": "mosaic/datepicker/datepicker-overview",
        "title": "Datepicker",
        "componentName": "DatepickerOverviewExample",
        "files": [
            "datepicker-overview-example.ts",
            "datepicker-overview-example.html",
            "datepicker-overview-example.css"
        ],
        "selector": "datepicker-overview-example",
        "additionalComponents": [],
        "primaryFile": "datepicker-overview-example.ts",
        "module": {
            "name": "DatepickerExamplesModule",
            "importSpecifier": "mosaic/datepicker",
            "importPath": "ptsecurity-mosaic-examples-mosaic-datepicker"
        }
    },
    "divider-overview": {
        "packagePath": "mosaic/divider/divider-overview",
        "title": "Divider",
        "componentName": "DividerOverviewExample",
        "files": [
            "divider-overview-example.ts",
            "divider-overview-example.html",
            "divider-overview-example.css"
        ],
        "selector": "divider-overview-example",
        "additionalComponents": [],
        "primaryFile": "divider-overview-example.ts",
        "module": {
            "name": "DividerExamplesModule",
            "importSpecifier": "mosaic/divider",
            "importPath": "ptsecurity-mosaic-examples-mosaic-divider"
        }
    },
    "divider-vertical": {
        "packagePath": "mosaic/divider/divider-vertical",
        "title": "divider-vertical",
        "componentName": "DividerVerticalExample",
        "files": [
            "divider-vertical-example.ts",
            "divider-vertical-example.html",
            "divider-vertical-example.css"
        ],
        "selector": "divider-vertical-example",
        "additionalComponents": [],
        "primaryFile": "divider-vertical-example.ts",
        "module": {
            "name": "DividerExamplesModule",
            "importSpecifier": "mosaic/divider",
            "importPath": "ptsecurity-mosaic-examples-mosaic-divider"
        }
    },
    "dropdown-navigation-wrap": {
        "packagePath": "mosaic/dropdown/dropdown-navigation-wrap",
        "title": "Basic dropdown",
        "componentName": "DropdownNavigationWrapExample",
        "files": [
            "dropdown-navigation-wrap-example.ts",
            "dropdown-navigation-wrap-example.html",
            "dropdown-navigation-wrap-example.css"
        ],
        "selector": "dropdown-navigation-wrap-example",
        "additionalComponents": [],
        "primaryFile": "dropdown-navigation-wrap-example.ts",
        "module": {
            "name": "DropdownExamplesModule",
            "importSpecifier": "mosaic/dropdown",
            "importPath": "ptsecurity-mosaic-examples-mosaic-dropdown"
        }
    },
    "dropdown-nested": {
        "packagePath": "mosaic/dropdown/dropdown-nested",
        "title": "Nested dropdown",
        "componentName": "DropdownNestedExample",
        "files": [
            "dropdown-nested-example.ts",
            "dropdown-nested-example.html",
            "dropdown-nested-example.css"
        ],
        "selector": "dropdown-nested-example",
        "additionalComponents": [],
        "primaryFile": "dropdown-nested-example.ts",
        "module": {
            "name": "DropdownExamplesModule",
            "importSpecifier": "mosaic/dropdown",
            "importPath": "ptsecurity-mosaic-examples-mosaic-dropdown"
        }
    },
    "dropdown-overview": {
        "packagePath": "mosaic/dropdown/dropdown-overview",
        "title": "Basic dropdown",
        "componentName": "DropdownOverviewExample",
        "files": [
            "dropdown-overview-example.ts",
            "dropdown-overview-example.html",
            "dropdown-overview-example.css"
        ],
        "selector": "dropdown-overview-example",
        "additionalComponents": [],
        "primaryFile": "dropdown-overview-example.ts",
        "module": {
            "name": "DropdownExamplesModule",
            "importSpecifier": "mosaic/dropdown",
            "importPath": "ptsecurity-mosaic-examples-mosaic-dropdown"
        }
    },
    "horizontal-form": {
        "packagePath": "mosaic/forms/horizontal-form",
        "title": "Horizontal form",
        "componentName": "HorizontalFormExample",
        "files": [
            "horizontal-form-example.ts",
            "horizontal-form-example.html",
            "horizontal-form-example.css"
        ],
        "selector": "horizontal-form-example",
        "additionalComponents": [],
        "primaryFile": "horizontal-form-example.ts",
        "module": {
            "name": "FormsExamplesModule",
            "importSpecifier": "mosaic/forms",
            "importPath": "ptsecurity-mosaic-examples-mosaic-forms"
        }
    },
    "vertical-form": {
        "packagePath": "mosaic/forms/vertical-form",
        "title": "Vertical form",
        "componentName": "VerticalFormExample",
        "files": [
            "vertical-form-example.ts",
            "vertical-form-example.html",
            "vertical-form-example.css"
        ],
        "selector": "vertical-form-example",
        "additionalComponents": [],
        "primaryFile": "vertical-form-example.ts",
        "module": {
            "name": "FormsExamplesModule",
            "importSpecifier": "mosaic/forms",
            "importPath": "ptsecurity-mosaic-examples-mosaic-forms"
        }
    },
    "input-number-overview": {
        "packagePath": "mosaic/input/input-number-overview",
        "title": "Basic Input",
        "componentName": "InputNumberOverviewExample",
        "files": [
            "input-number-overview-example.ts",
            "input-number-overview-example.html",
            "input-number-overview-example.css"
        ],
        "selector": "input-number-overview-example",
        "additionalComponents": [],
        "primaryFile": "input-number-overview-example.ts",
        "module": {
            "name": "InputExamplesModule",
            "importSpecifier": "mosaic/input",
            "importPath": "ptsecurity-mosaic-examples-mosaic-input"
        }
    },
    "input-overview": {
        "packagePath": "mosaic/input/input-overview",
        "title": "Basic Input",
        "componentName": "InputOverviewExample",
        "files": [
            "input-overview-example.ts",
            "input-overview-example.html",
            "input-overview-example.css"
        ],
        "selector": "input-overview-example",
        "additionalComponents": [],
        "primaryFile": "input-overview-example.ts",
        "module": {
            "name": "InputExamplesModule",
            "importSpecifier": "mosaic/input",
            "importPath": "ptsecurity-mosaic-examples-mosaic-input"
        }
    },
    "layout-flex-alignment": {
        "packagePath": "mosaic/layout-flex/layout-flex-alignment",
        "title": "Flex layout",
        "componentName": "LayoutFlexAlignmentExample",
        "files": [
            "layout-flex-alignment-example.ts",
            "layout-flex-alignment-example.html",
            "layout-flex-alignment-example.css"
        ],
        "selector": "layout-flex-alignment-example",
        "additionalComponents": [],
        "primaryFile": "layout-flex-alignment-example.ts",
        "module": {
            "name": "FlexLayoutExamplesModule",
            "importSpecifier": "mosaic/layout-flex",
            "importPath": "ptsecurity-mosaic-examples-mosaic-layout-flex"
        }
    },
    "layout-flex-behaviour-modifiers": {
        "packagePath": "mosaic/layout-flex/layout-flex-behaviour-modifiers",
        "title": "Flex layout",
        "componentName": "LayoutFlexBehaviourModifiersExample",
        "files": [
            "layout-flex-behaviour-modifiers-example.ts",
            "layout-flex-behaviour-modifiers-example.html",
            "layout-flex-behaviour-modifiers-example.css"
        ],
        "selector": "layout-flex-behaviour-modifiers-example",
        "additionalComponents": [],
        "primaryFile": "layout-flex-behaviour-modifiers-example.ts",
        "module": {
            "name": "FlexLayoutExamplesModule",
            "importSpecifier": "mosaic/layout-flex",
            "importPath": "ptsecurity-mosaic-examples-mosaic-layout-flex"
        }
    },
    "layout-flex-offsets": {
        "packagePath": "mosaic/layout-flex/layout-flex-offsets",
        "title": "Flex layout",
        "componentName": "LayoutFlexOffsetsExample",
        "files": [
            "layout-flex-offsets-example.ts",
            "layout-flex-offsets-example.html",
            "layout-flex-offsets-example.css"
        ],
        "selector": "layout-flex-offsets-example",
        "additionalComponents": [],
        "primaryFile": "layout-flex-offsets-example.ts",
        "module": {
            "name": "FlexLayoutExamplesModule",
            "importSpecifier": "mosaic/layout-flex",
            "importPath": "ptsecurity-mosaic-examples-mosaic-layout-flex"
        }
    },
    "layout-flex-order": {
        "packagePath": "mosaic/layout-flex/layout-flex-order",
        "title": "Flex layout",
        "componentName": "LayoutFlexOrderExample",
        "files": [
            "layout-flex-order-example.ts",
            "layout-flex-order-example.html",
            "layout-flex-order-example.css"
        ],
        "selector": "layout-flex-order-example",
        "additionalComponents": [],
        "primaryFile": "layout-flex-order-example.ts",
        "module": {
            "name": "FlexLayoutExamplesModule",
            "importSpecifier": "mosaic/layout-flex",
            "importPath": "ptsecurity-mosaic-examples-mosaic-layout-flex"
        }
    },
    "layout-flex-overview": {
        "packagePath": "mosaic/layout-flex/layout-flex-overview",
        "title": "Flex layout",
        "componentName": "LayoutFlexOverviewExample",
        "files": [
            "layout-flex-overview-example.ts",
            "layout-flex-overview-example.html",
            "layout-flex-overview-example.css"
        ],
        "selector": "layout-flex-overview-example",
        "additionalComponents": [],
        "primaryFile": "layout-flex-overview-example.ts",
        "module": {
            "name": "FlexLayoutExamplesModule",
            "importSpecifier": "mosaic/layout-flex",
            "importPath": "ptsecurity-mosaic-examples-mosaic-layout-flex"
        }
    },
    "link-application": {
        "packagePath": "mosaic/link/link-application",
        "title": "Basic link",
        "componentName": "LinkApplicationExample",
        "files": [
            "link-application-example.ts",
            "link-application-example.html",
            "link-application-example.css"
        ],
        "selector": "link-application-example",
        "additionalComponents": [],
        "primaryFile": "link-application-example.ts",
        "module": {
            "name": "LinkExamplesModule",
            "importSpecifier": "mosaic/link",
            "importPath": "ptsecurity-mosaic-examples-mosaic-link"
        }
    },
    "link-color": {
        "packagePath": "mosaic/link/link-color",
        "title": "Basic link",
        "componentName": "LinkColorExample",
        "files": [
            "link-color-example.ts",
            "link-color-example.html",
            "link-color-example.css"
        ],
        "selector": "link-color-example",
        "additionalComponents": [],
        "primaryFile": "link-color-example.ts",
        "module": {
            "name": "LinkExamplesModule",
            "importSpecifier": "mosaic/link",
            "importPath": "ptsecurity-mosaic-examples-mosaic-link"
        }
    },
    "link-disabled": {
        "packagePath": "mosaic/link/link-disabled",
        "title": "Pseudo link",
        "componentName": "LinkDisabledExample",
        "files": [
            "link-disabled-example.ts",
            "link-disabled-example.html",
            "link-disabled-example.css"
        ],
        "selector": "link-disabled-example",
        "additionalComponents": [],
        "primaryFile": "link-disabled-example.ts",
        "module": {
            "name": "LinkExamplesModule",
            "importSpecifier": "mosaic/link",
            "importPath": "ptsecurity-mosaic-examples-mosaic-link"
        }
    },
    "link-external": {
        "packagePath": "mosaic/link/link-external",
        "title": "Basic link",
        "componentName": "LinkExternalExample",
        "files": [
            "link-external-example.ts",
            "link-external-example.html",
            "link-external-example.css"
        ],
        "selector": "link-external-example",
        "additionalComponents": [],
        "primaryFile": "link-external-example.ts",
        "module": {
            "name": "LinkExamplesModule",
            "importSpecifier": "mosaic/link",
            "importPath": "ptsecurity-mosaic-examples-mosaic-link"
        }
    },
    "link-general": {
        "packagePath": "mosaic/link/link-general",
        "title": "Basic link",
        "componentName": "LinkGeneralExample",
        "files": [
            "link-general-example.ts",
            "link-general-example.html",
            "link-general-example.css"
        ],
        "selector": "link-general-example",
        "additionalComponents": [],
        "primaryFile": "link-general-example.ts",
        "module": {
            "name": "LinkExamplesModule",
            "importSpecifier": "mosaic/link",
            "importPath": "ptsecurity-mosaic-examples-mosaic-link"
        }
    },
    "link-icons": {
        "packagePath": "mosaic/link/link-icons",
        "title": "Basic link",
        "componentName": "LinkIconsExample",
        "files": [
            "link-icons-example.ts",
            "link-icons-example.html",
            "link-icons-example.css"
        ],
        "selector": "link-icons-example",
        "additionalComponents": [],
        "primaryFile": "link-icons-example.ts",
        "module": {
            "name": "LinkExamplesModule",
            "importSpecifier": "mosaic/link",
            "importPath": "ptsecurity-mosaic-examples-mosaic-link"
        }
    },
    "link-multi-line": {
        "packagePath": "mosaic/link/link-multi-line",
        "title": "Basic link",
        "componentName": "LinkMultiLineExample",
        "files": [
            "link-multi-line-example.ts",
            "link-multi-line-example.html",
            "link-multi-line-example.css"
        ],
        "selector": "link-multi-line-example",
        "additionalComponents": [],
        "primaryFile": "link-multi-line-example.ts",
        "module": {
            "name": "LinkExamplesModule",
            "importSpecifier": "mosaic/link",
            "importPath": "ptsecurity-mosaic-examples-mosaic-link"
        }
    },
    "link-overview": {
        "packagePath": "mosaic/link/link-overview",
        "title": "Basic link",
        "componentName": "LinkOverviewExample",
        "files": [
            "link-overview-example.ts",
            "link-overview-example.html",
            "link-overview-example.css"
        ],
        "selector": "link-overview-example",
        "additionalComponents": [],
        "primaryFile": "link-overview-example.ts",
        "module": {
            "name": "LinkExamplesModule",
            "importSpecifier": "mosaic/link",
            "importPath": "ptsecurity-mosaic-examples-mosaic-link"
        }
    },
    "link-prepositions": {
        "packagePath": "mosaic/link/link-prepositions",
        "title": "Basic link",
        "componentName": "LinkPrepositionsExample",
        "files": [
            "link-prepositions-example.ts",
            "link-prepositions-example.html",
            "link-prepositions-example.css"
        ],
        "selector": "link-prepositions-example",
        "additionalComponents": [],
        "primaryFile": "link-prepositions-example.ts",
        "module": {
            "name": "LinkExamplesModule",
            "importSpecifier": "mosaic/link",
            "importPath": "ptsecurity-mosaic-examples-mosaic-link"
        }
    },
    "link-print": {
        "packagePath": "mosaic/link/link-print",
        "title": "Basic link",
        "componentName": "LinkPrintExample",
        "files": [
            "link-print-example.ts",
            "link-print-example.html",
            "link-print-example.css"
        ],
        "selector": "link-print-example",
        "additionalComponents": [],
        "primaryFile": "link-print-example.ts",
        "module": {
            "name": "LinkExamplesModule",
            "importSpecifier": "mosaic/link",
            "importPath": "ptsecurity-mosaic-examples-mosaic-link"
        }
    },
    "link-pseudo": {
        "packagePath": "mosaic/link/link-pseudo",
        "title": "Pseudo link",
        "componentName": "LinkPseudoExample",
        "files": [
            "link-pseudo-example.ts",
            "link-pseudo-example.html",
            "link-pseudo-example.css"
        ],
        "selector": "link-pseudo-example",
        "additionalComponents": [],
        "primaryFile": "link-pseudo-example.ts",
        "module": {
            "name": "LinkExamplesModule",
            "importSpecifier": "mosaic/link",
            "importPath": "ptsecurity-mosaic-examples-mosaic-link"
        }
    },
    "link-target-blank": {
        "packagePath": "mosaic/link/link-target-blank",
        "title": "Basic link",
        "componentName": "LinkTargetBlankExample",
        "files": [
            "link-target-blank-example.ts",
            "link-target-blank-example.html",
            "link-target-blank-example.css"
        ],
        "selector": "link-target-blank-example",
        "additionalComponents": [],
        "primaryFile": "link-target-blank-example.ts",
        "module": {
            "name": "LinkExamplesModule",
            "importSpecifier": "mosaic/link",
            "importPath": "ptsecurity-mosaic-examples-mosaic-link"
        }
    },
    "link-visited": {
        "packagePath": "mosaic/link/link-visited",
        "title": "Pseudo link",
        "componentName": "LinkVisitedExample",
        "files": [
            "link-visited-example.ts",
            "link-visited-example.html",
            "link-visited-example.css"
        ],
        "selector": "link-visited-example",
        "additionalComponents": [],
        "primaryFile": "link-visited-example.ts",
        "module": {
            "name": "LinkExamplesModule",
            "importSpecifier": "mosaic/link",
            "importPath": "ptsecurity-mosaic-examples-mosaic-link"
        }
    },
    "list-action-button": {
        "packagePath": "mosaic/list/list-action-button",
        "title": "list ActionButton",
        "componentName": "ListActionButtonExample",
        "files": [
            "list-action-button-example.ts",
            "list-action-button-example.html",
            "list-action-button-example.css"
        ],
        "selector": "list-action-button-example",
        "additionalComponents": [],
        "primaryFile": "list-action-button-example.ts",
        "module": {
            "name": "ListExamplesModule",
            "importSpecifier": "mosaic/list",
            "importPath": "ptsecurity-mosaic-examples-mosaic-list"
        }
    },
    "list-groups": {
        "packagePath": "mosaic/list/list-groups",
        "title": "Basic list",
        "componentName": "ListGroupsExample",
        "files": [
            "list-groups-example.ts",
            "list-groups-example.html",
            "list-groups-example.css"
        ],
        "selector": "list-groups-example",
        "additionalComponents": [],
        "primaryFile": "list-groups-example.ts",
        "module": {
            "name": "ListExamplesModule",
            "importSpecifier": "mosaic/list",
            "importPath": "ptsecurity-mosaic-examples-mosaic-list"
        }
    },
    "list-multiple-checkbox": {
        "packagePath": "mosaic/list/list-multiple-checkbox",
        "title": "Basic list",
        "componentName": "ListMultipleCheckboxExample",
        "files": [
            "list-multiple-checkbox-example.ts",
            "list-multiple-checkbox-example.html",
            "list-multiple-checkbox-example.css"
        ],
        "selector": "list-multiple-checkbox-example",
        "additionalComponents": [],
        "primaryFile": "list-multiple-checkbox-example.ts",
        "module": {
            "name": "ListExamplesModule",
            "importSpecifier": "mosaic/list",
            "importPath": "ptsecurity-mosaic-examples-mosaic-list"
        }
    },
    "list-multiple-keyboard": {
        "packagePath": "mosaic/list/list-multiple-keyboard",
        "title": "Basic list",
        "componentName": "ListMultipleKeyboardExample",
        "files": [
            "list-multiple-keyboard-example.ts",
            "list-multiple-keyboard-example.html",
            "list-multiple-keyboard-example.css"
        ],
        "selector": "list-multiple-keyboard-example",
        "additionalComponents": [],
        "primaryFile": "list-multiple-keyboard-example.ts",
        "module": {
            "name": "ListExamplesModule",
            "importSpecifier": "mosaic/list",
            "importPath": "ptsecurity-mosaic-examples-mosaic-list"
        }
    },
    "list-overview": {
        "packagePath": "mosaic/list/list-overview",
        "title": "Basic list",
        "componentName": "ListOverviewExample",
        "files": [
            "list-overview-example.ts",
            "list-overview-example.html",
            "list-overview-example.css"
        ],
        "selector": "list-overview-example",
        "additionalComponents": [],
        "primaryFile": "list-overview-example.ts",
        "module": {
            "name": "ListExamplesModule",
            "importSpecifier": "mosaic/list",
            "importPath": "ptsecurity-mosaic-examples-mosaic-list"
        }
    },
    "modal-component": {
        "packagePath": "mosaic/modal/modal-component",
        "title": "Component Modal",
        "componentName": "ModalComponentExample",
        "files": [
            "modal-component-example.ts",
            "modal-component-example.html",
            "modal-component-example.css"
        ],
        "selector": "modal-component-example",
        "additionalComponents": [
            "McModalCustomComponent"
        ],
        "primaryFile": "modal-component-example.ts",
        "module": {
            "name": "ModalExamplesModule",
            "importSpecifier": "mosaic/modal",
            "importPath": "ptsecurity-mosaic-examples-mosaic-modal"
        }
    },
    "modal-focus-content": {
        "packagePath": "mosaic/modal/modal-focus-content",
        "title": "Modal with focused content",
        "componentName": "ModalFocusContentExample",
        "files": [
            "modal-focus-content-example.ts",
            "modal-focus-content-example.html",
            "modal-focus-content-example.css"
        ],
        "selector": "modal-focus-content-example",
        "additionalComponents": [
            "McModalFocusContentComponent"
        ],
        "primaryFile": "modal-focus-content-example.ts",
        "module": {
            "name": "ModalExamplesModule",
            "importSpecifier": "mosaic/modal",
            "importPath": "ptsecurity-mosaic-examples-mosaic-modal"
        }
    },
    "modal-overview": {
        "packagePath": "mosaic/modal/modal-overview",
        "title": "Basic Modal",
        "componentName": "ModalOverviewExample",
        "files": [
            "modal-overview-example.ts",
            "modal-overview-example.html",
            "modal-overview-example.css"
        ],
        "selector": "modal-overview-example",
        "additionalComponents": [],
        "primaryFile": "modal-overview-example.ts",
        "module": {
            "name": "ModalExamplesModule",
            "importSpecifier": "mosaic/modal",
            "importPath": "ptsecurity-mosaic-examples-mosaic-modal"
        }
    },
    "modal-scroll": {
        "packagePath": "mosaic/modal/modal-scroll",
        "title": "Component Modal Scroll",
        "componentName": "ModalScrollExample",
        "files": [
            "modal-scroll-example.ts",
            "modal-scroll-example.css"
        ],
        "selector": "modal-scroll-example",
        "additionalComponents": [
            "McLongComponent"
        ],
        "primaryFile": "modal-scroll-example.ts",
        "module": {
            "name": "ModalExamplesModule",
            "importSpecifier": "mosaic/modal",
            "importPath": "ptsecurity-mosaic-examples-mosaic-modal"
        }
    },
    "modal-sizes": {
        "packagePath": "mosaic/modal/modal-sizes",
        "title": "Sizes Modal",
        "componentName": "ModalSizesExample",
        "files": [
            "modal-sizes-example.ts",
            "modal-sizes-example.html",
            "modal-sizes-example.css"
        ],
        "selector": "modal-sizes-example",
        "additionalComponents": [],
        "primaryFile": "modal-sizes-example.ts",
        "module": {
            "name": "ModalExamplesModule",
            "importSpecifier": "mosaic/modal",
            "importPath": "ptsecurity-mosaic-examples-mosaic-modal"
        }
    },
    "modal-template": {
        "packagePath": "mosaic/modal/modal-template",
        "title": "Template Modal",
        "componentName": "ModalTemplateExample",
        "files": [
            "modal-template-example.ts",
            "modal-template-example.html",
            "modal-template-example.css"
        ],
        "selector": "modal-template-example",
        "additionalComponents": [],
        "primaryFile": "modal-template-example.ts",
        "module": {
            "name": "ModalExamplesModule",
            "importSpecifier": "mosaic/modal",
            "importPath": "ptsecurity-mosaic-examples-mosaic-modal"
        }
    },
    "navbar-overview": {
        "packagePath": "mosaic/navbar/navbar-overview",
        "title": "Navbar",
        "componentName": "NavbarOverviewExample",
        "files": [
            "navbar-overview-example.ts",
            "navbar-overview-example.html",
            "navbar-overview-example.css"
        ],
        "selector": "navbar-overview-example",
        "additionalComponents": [],
        "primaryFile": "navbar-overview-example.ts",
        "module": {
            "name": "NavbarExamplesModule",
            "importSpecifier": "mosaic/navbar",
            "importPath": "ptsecurity-mosaic-examples-mosaic-navbar"
        }
    },
    "navbar-vertical": {
        "packagePath": "mosaic/navbar/navbar-vertical",
        "title": "Vertical Navbar",
        "componentName": "NavbarVerticalExample",
        "files": [
            "navbar-vertical-example.ts",
            "navbar-vertical-example.html",
            "navbar-vertical-example.css"
        ],
        "selector": "navbar-vertical-example",
        "additionalComponents": [],
        "primaryFile": "navbar-vertical-example.ts",
        "module": {
            "name": "NavbarExamplesModule",
            "importSpecifier": "mosaic/navbar",
            "importPath": "ptsecurity-mosaic-examples-mosaic-navbar"
        }
    },
    "number-formatter-overview": {
        "packagePath": "mosaic/number-formatter/number-formatter-overview",
        "title": "Basic progress number-formatter",
        "componentName": "NumberFormatterOverviewExample",
        "files": [
            "number-formatter-overview-example.ts",
            "number-formatter-overview-example.html",
            "number-formatter-overview-example.css",
            "formatters-template.html",
            "formatters-template.html"
        ],
        "selector": "number-formatter-overview-example",
        "additionalComponents": [
            "WithDefaultLocaleComponent",
            "WithENLocaleComponent"
        ],
        "primaryFile": "number-formatter-overview-example.ts",
        "module": {
            "name": "NumberFormatterExamplesModule",
            "importSpecifier": "mosaic/number-formatter",
            "importPath": "ptsecurity-mosaic-examples-mosaic-number-formatter"
        }
    },
    "popover-instance": {
        "packagePath": "mosaic/popover/popover-instance",
        "title": "popover-instance",
        "componentName": "PopoverInstanceExample",
        "files": [
            "popover-instance-example.ts",
            "popover-instance-example.html",
            "popover-instance-example.css"
        ],
        "selector": "popover-instance-example",
        "additionalComponents": [],
        "primaryFile": "popover-instance-example.ts",
        "module": {
            "name": "PopoverExamplesModule",
            "importSpecifier": "mosaic/popover",
            "importPath": "ptsecurity-mosaic-examples-mosaic-popover"
        }
    },
    "popover-overview": {
        "packagePath": "mosaic/popover/popover-overview",
        "title": "Basic popover",
        "componentName": "PopoverOverviewExample",
        "files": [
            "popover-overview-example.ts",
            "popover-overview-example.html",
            "popover-overview-example.css"
        ],
        "selector": "popover-overview-example",
        "additionalComponents": [],
        "primaryFile": "popover-overview-example.ts",
        "module": {
            "name": "PopoverExamplesModule",
            "importSpecifier": "mosaic/popover",
            "importPath": "ptsecurity-mosaic-examples-mosaic-popover"
        }
    },
    "progress-bar-indeterminate": {
        "packagePath": "mosaic/progress-bar/progress-bar-indeterminate",
        "title": "Indeterminate progress bar",
        "componentName": "ProgressBarIndeterminateExample",
        "files": [
            "progress-bar-indeterminate-example.ts",
            "progress-bar-indeterminate-example.html",
            "progress-bar-indeterminate-example.css"
        ],
        "selector": "progress-bar-indeterminate-example",
        "additionalComponents": [],
        "primaryFile": "progress-bar-indeterminate-example.ts",
        "module": {
            "name": "ProgressBarExamplesModule",
            "importSpecifier": "mosaic/progress-bar",
            "importPath": "ptsecurity-mosaic-examples-mosaic-progress-bar"
        }
    },
    "progress-bar-overview": {
        "packagePath": "mosaic/progress-bar/progress-bar-overview",
        "title": "Basic progress bar",
        "componentName": "ProgressBarOverviewExample",
        "files": [
            "progress-bar-overview-example.ts",
            "progress-bar-overview-example.html",
            "progress-bar-overview-example.css"
        ],
        "selector": "progress-bar-overview-example",
        "additionalComponents": [],
        "primaryFile": "progress-bar-overview-example.ts",
        "module": {
            "name": "ProgressBarExamplesModule",
            "importSpecifier": "mosaic/progress-bar",
            "importPath": "ptsecurity-mosaic-examples-mosaic-progress-bar"
        }
    },
    "progress-spinner-indeterminate": {
        "packagePath": "mosaic/progress-spinner/progress-spinner-indeterminate",
        "title": "Indeterminate progress spinner",
        "componentName": "ProgressSpinnerIndeterminateExample",
        "files": [
            "progress-spinner-indeterminate-example.ts",
            "progress-spinner-indeterminate-example.html",
            "progress-spinner-indeterminate-example.css"
        ],
        "selector": "progress-spinner-indeterminate-example",
        "additionalComponents": [],
        "primaryFile": "progress-spinner-indeterminate-example.ts",
        "module": {
            "name": "ProgressSpinnerExamplesModule",
            "importSpecifier": "mosaic/progress-spinner",
            "importPath": "ptsecurity-mosaic-examples-mosaic-progress-spinner"
        }
    },
    "progress-spinner-overview": {
        "packagePath": "mosaic/progress-spinner/progress-spinner-overview",
        "title": "Basic progress spinner",
        "componentName": "ProgressSpinnerOverviewExample",
        "files": [
            "progress-spinner-overview-example.ts",
            "progress-spinner-overview-example.html",
            "progress-spinner-overview-example.css"
        ],
        "selector": "progress-spinner-overview-example",
        "additionalComponents": [],
        "primaryFile": "progress-spinner-overview-example.ts",
        "module": {
            "name": "ProgressSpinnerExamplesModule",
            "importSpecifier": "mosaic/progress-spinner",
            "importPath": "ptsecurity-mosaic-examples-mosaic-progress-spinner"
        }
    },
    "radio-overview": {
        "packagePath": "mosaic/radio/radio-overview",
        "title": "Basic radio",
        "componentName": "RadioOverviewExample",
        "files": [
            "radio-overview-example.ts",
            "radio-overview-example.html",
            "radio-overview-example.css"
        ],
        "selector": "radio-overview-example",
        "additionalComponents": [],
        "primaryFile": "radio-overview-example.ts",
        "module": {
            "name": "RadioExamplesModule",
            "importSpecifier": "mosaic/radio",
            "importPath": "ptsecurity-mosaic-examples-mosaic-radio"
        }
    },
    "select-groups": {
        "packagePath": "mosaic/select/select-groups",
        "title": "Basic Select",
        "componentName": "SelectGroupsExample",
        "files": [
            "select-groups-example.ts",
            "select-groups-example.html",
            "select-groups-example.css"
        ],
        "selector": "select-groups-example",
        "additionalComponents": [],
        "primaryFile": "select-groups-example.ts",
        "module": {
            "name": "SelectExamplesModule",
            "importSpecifier": "mosaic/select",
            "importPath": "ptsecurity-mosaic-examples-mosaic-select"
        }
    },
    "select-multiple-overview": {
        "packagePath": "mosaic/select/select-multiple-overview",
        "title": "Basic Select",
        "componentName": "SelectMultipleOverviewExample",
        "files": [
            "select-multiple-overview-example.ts",
            "select-multiple-overview-example.html",
            "select-multiple-overview-example.css"
        ],
        "selector": "select-multiple-overview-example",
        "additionalComponents": [],
        "primaryFile": "select-multiple-overview-example.ts",
        "module": {
            "name": "SelectExamplesModule",
            "importSpecifier": "mosaic/select",
            "importPath": "ptsecurity-mosaic-examples-mosaic-select"
        }
    },
    "select-overview": {
        "packagePath": "mosaic/select/select-overview",
        "title": "Basic Select",
        "componentName": "SelectOverviewExample",
        "files": [
            "select-overview-example.ts",
            "select-overview-example.html",
            "select-overview-example.css"
        ],
        "selector": "select-overview-example",
        "additionalComponents": [],
        "primaryFile": "select-overview-example.ts",
        "module": {
            "name": "SelectExamplesModule",
            "importSpecifier": "mosaic/select",
            "importPath": "ptsecurity-mosaic-examples-mosaic-select"
        }
    },
    "select-search-overview": {
        "packagePath": "mosaic/select/select-search-overview",
        "title": "Basic Select",
        "componentName": "SelectSearchOverviewExample",
        "files": [
            "select-search-overview-example.ts",
            "select-search-overview-example.html",
            "select-search-overview-example.css"
        ],
        "selector": "select-search-overview-example",
        "additionalComponents": [],
        "primaryFile": "select-search-overview-example.ts",
        "module": {
            "name": "SelectExamplesModule",
            "importSpecifier": "mosaic/select",
            "importPath": "ptsecurity-mosaic-examples-mosaic-select"
        }
    },
    "select-virtual-scroll": {
        "packagePath": "mosaic/select/select-virtual-scroll",
        "title": "select-virtual-scroll",
        "componentName": "SelectVirtualScrollExample",
        "files": [
            "select-virtual-scroll-example.ts",
            "select-virtual-scroll-example.html",
            "select-virtual-scroll-example.css"
        ],
        "selector": "select-virtual-scroll-example",
        "additionalComponents": [],
        "primaryFile": "select-virtual-scroll-example.ts",
        "module": {
            "name": "SelectExamplesModule",
            "importSpecifier": "mosaic/select",
            "importPath": "ptsecurity-mosaic-examples-mosaic-select"
        }
    },
    "sidepanel-component": {
        "packagePath": "mosaic/sidepanel/sidepanel-component",
        "title": "Template Modal",
        "componentName": "SidepanelComponentExample",
        "files": [
            "sidepanel-component-example.ts",
            "sidepanel-component-example.html",
            "sidepanel-component-example.css"
        ],
        "selector": "sidepanel-component-example",
        "additionalComponents": [
            "SidepanelExampleCustomComponent"
        ],
        "primaryFile": "sidepanel-component-example.ts",
        "module": {
            "name": "SidepanelExamplesModule",
            "importSpecifier": "mosaic/sidepanel",
            "importPath": "ptsecurity-mosaic-examples-mosaic-sidepanel"
        }
    },
    "sidepanel-overview": {
        "packagePath": "mosaic/sidepanel/sidepanel-overview",
        "title": "Template Modal",
        "componentName": "SidepanelOverviewExample",
        "files": [
            "sidepanel-overview-example.ts",
            "sidepanel-overview-example.html",
            "sidepanel-overview-example.css"
        ],
        "selector": "sidepanel-overview-example",
        "additionalComponents": [],
        "primaryFile": "sidepanel-overview-example.ts",
        "module": {
            "name": "SidepanelExamplesModule",
            "importSpecifier": "mosaic/sidepanel",
            "importPath": "ptsecurity-mosaic-examples-mosaic-sidepanel"
        }
    },
    "splitter-fixed": {
        "packagePath": "mosaic/splitter/splitter-fixed",
        "title": "Basic Splitter",
        "componentName": "SplitterFixedExample",
        "files": [
            "splitter-fixed-example.ts",
            "splitter-fixed-example.html",
            "splitter-fixed-example.css"
        ],
        "selector": "splitter-fixed-example",
        "additionalComponents": [],
        "primaryFile": "splitter-fixed-example.ts",
        "module": {
            "name": "SplitterExamplesModule",
            "importSpecifier": "mosaic/splitter",
            "importPath": "ptsecurity-mosaic-examples-mosaic-splitter"
        }
    },
    "splitter-nested": {
        "packagePath": "mosaic/splitter/splitter-nested",
        "title": "Basic Splitter",
        "componentName": "SplitterNestedExample",
        "files": [
            "splitter-nested-example.ts",
            "splitter-nested-example.html",
            "splitter-nested-example.css"
        ],
        "selector": "splitter-nested-example",
        "additionalComponents": [],
        "primaryFile": "splitter-nested-example.ts",
        "module": {
            "name": "SplitterExamplesModule",
            "importSpecifier": "mosaic/splitter",
            "importPath": "ptsecurity-mosaic-examples-mosaic-splitter"
        }
    },
    "splitter-overview": {
        "packagePath": "mosaic/splitter/splitter-overview",
        "title": "Basic Splitter",
        "componentName": "SplitterOverviewExample",
        "files": [
            "splitter-overview-example.ts",
            "splitter-overview-example.html",
            "splitter-overview-example.css"
        ],
        "selector": "splitter-overview-example",
        "additionalComponents": [],
        "primaryFile": "splitter-overview-example.ts",
        "module": {
            "name": "SplitterExamplesModule",
            "importSpecifier": "mosaic/splitter",
            "importPath": "ptsecurity-mosaic-examples-mosaic-splitter"
        }
    },
    "splitter-vertical": {
        "packagePath": "mosaic/splitter/splitter-vertical",
        "title": "Basic Splitter",
        "componentName": "SplitterVerticalExample",
        "files": [
            "splitter-vertical-example.ts",
            "splitter-vertical-example.html",
            "splitter-vertical-example.css"
        ],
        "selector": "splitter-vertical-example",
        "additionalComponents": [],
        "primaryFile": "splitter-vertical-example.ts",
        "module": {
            "name": "SplitterExamplesModule",
            "importSpecifier": "mosaic/splitter",
            "importPath": "ptsecurity-mosaic-examples-mosaic-splitter"
        }
    },
    "table-overview": {
        "packagePath": "mosaic/table/table-overview",
        "title": "Basic Table",
        "componentName": "TableOverviewExample",
        "files": [
            "table-overview-example.ts",
            "table-overview-example.html",
            "table-overview-example.css"
        ],
        "selector": "table-overview-example",
        "additionalComponents": [],
        "primaryFile": "table-overview-example.ts",
        "module": {
            "name": "TableExamplesModule",
            "importSpecifier": "mosaic/table",
            "importPath": "ptsecurity-mosaic-examples-mosaic-table"
        }
    },
    "table-with-borders": {
        "packagePath": "mosaic/table/table-with-borders",
        "title": "Basic Table",
        "componentName": "TableWithBordersExample",
        "files": [
            "table-with-borders-example.ts",
            "table-with-borders-example.html",
            "table-with-borders-example.css"
        ],
        "selector": "table-with-borders-example",
        "additionalComponents": [],
        "primaryFile": "table-with-borders-example.ts",
        "module": {
            "name": "TableExamplesModule",
            "importSpecifier": "mosaic/table",
            "importPath": "ptsecurity-mosaic-examples-mosaic-table"
        }
    },
    "tabs-empty": {
        "packagePath": "mosaic/tabs/tabs-empty",
        "title": "Tabs empty",
        "componentName": "TabsEmptyExample",
        "files": [
            "tabs-empty-example.ts",
            "tabs-empty-example.html",
            "tabs-empty-example.css"
        ],
        "selector": "tabs-empty-example",
        "additionalComponents": [],
        "primaryFile": "tabs-empty-example.ts",
        "module": {
            "name": "TabsExamplesModule",
            "importSpecifier": "mosaic/tabs",
            "importPath": "ptsecurity-mosaic-examples-mosaic-tabs"
        }
    },
    "tabs-old": {
        "packagePath": "mosaic/tabs/tabs-old",
        "title": "Navbar",
        "componentName": "TabsOldExample",
        "files": [
            "tabs-old-example.ts",
            "tabs-old-example.html",
            "tabs-old-example.css"
        ],
        "selector": "tabs-old-example",
        "additionalComponents": [],
        "primaryFile": "tabs-old-example.ts",
        "module": {
            "name": "TabsExamplesModule",
            "importSpecifier": "mosaic/tabs",
            "importPath": "ptsecurity-mosaic-examples-mosaic-tabs"
        }
    },
    "tabs-overview": {
        "packagePath": "mosaic/tabs/tabs-overview",
        "title": "Tabs",
        "componentName": "TabsOverviewExample",
        "files": [
            "tabs-overview-example.ts",
            "tabs-overview-example.html",
            "tabs-overview-example.css"
        ],
        "selector": "tabs-overview-example",
        "additionalComponents": [],
        "primaryFile": "tabs-overview-example.ts",
        "module": {
            "name": "TabsExamplesModule",
            "importSpecifier": "mosaic/tabs",
            "importPath": "ptsecurity-mosaic-examples-mosaic-tabs"
        }
    },
    "tabs-stretch": {
        "packagePath": "mosaic/tabs/tabs-stretch",
        "title": "Navbar",
        "componentName": "TabsStretchExample",
        "files": [
            "tabs-stretch-example.ts",
            "tabs-stretch-example.html",
            "tabs-stretch-example.css"
        ],
        "selector": "tabs-stretch-example",
        "additionalComponents": [],
        "primaryFile": "tabs-stretch-example.ts",
        "module": {
            "name": "TabsExamplesModule",
            "importSpecifier": "mosaic/tabs",
            "importPath": "ptsecurity-mosaic-examples-mosaic-tabs"
        }
    },
    "tabs-vertical": {
        "packagePath": "mosaic/tabs/tabs-vertical",
        "title": "Navbar",
        "componentName": "TabsVerticalExample",
        "files": [
            "tabs-vertical-example.ts",
            "tabs-vertical-example.html",
            "tabs-vertical-example.css"
        ],
        "selector": "tabs-vertical-example",
        "additionalComponents": [],
        "primaryFile": "tabs-vertical-example.ts",
        "module": {
            "name": "TabsExamplesModule",
            "importSpecifier": "mosaic/tabs",
            "importPath": "ptsecurity-mosaic-examples-mosaic-tabs"
        }
    },
    "tabs-with-scroll": {
        "packagePath": "mosaic/tabs/tabs-with-scroll",
        "title": "Navbar",
        "componentName": "TabsWithScrollExample",
        "files": [
            "tabs-with-scroll-example.ts",
            "tabs-with-scroll-example.html",
            "tabs-with-scroll-example.css"
        ],
        "selector": "tabs-with-scroll-example",
        "additionalComponents": [],
        "primaryFile": "tabs-with-scroll-example.ts",
        "module": {
            "name": "TabsExamplesModule",
            "importSpecifier": "mosaic/tabs",
            "importPath": "ptsecurity-mosaic-examples-mosaic-tabs"
        }
    },
    "tags-autocomplete": {
        "packagePath": "mosaic/tags/tags-autocomplete",
        "title": "Basic tags autocomplete",
        "componentName": "TagsAutocompleteExample",
        "files": [
            "tags-autocomplete-example.ts",
            "tags-autocomplete-example.html",
            "tags-autocomplete-example.css"
        ],
        "selector": "tags-autocomplete-example",
        "additionalComponents": [],
        "primaryFile": "tags-autocomplete-example.ts",
        "module": {
            "name": "TagsExamplesModule",
            "importSpecifier": "mosaic/tags",
            "importPath": "ptsecurity-mosaic-examples-mosaic-tags"
        }
    },
    "tags-input": {
        "packagePath": "mosaic/tags/tags-input",
        "title": "Basic tags input",
        "componentName": "TagsInputExample",
        "files": [
            "tags-input-example.ts",
            "tags-input-example.html",
            "tags-input-example.css"
        ],
        "selector": "tags-input-example",
        "additionalComponents": [],
        "primaryFile": "tags-input-example.ts",
        "module": {
            "name": "TagsExamplesModule",
            "importSpecifier": "mosaic/tags",
            "importPath": "ptsecurity-mosaic-examples-mosaic-tags"
        }
    },
    "tags-list": {
        "packagePath": "mosaic/tags/tags-list",
        "title": "Basic tags list",
        "componentName": "TagsListExample",
        "files": [
            "tags-list-example.ts",
            "tags-list-example.html",
            "tags-list-example.css"
        ],
        "selector": "tags-list-example",
        "additionalComponents": [],
        "primaryFile": "tags-list-example.ts",
        "module": {
            "name": "TagsExamplesModule",
            "importSpecifier": "mosaic/tags",
            "importPath": "ptsecurity-mosaic-examples-mosaic-tags"
        }
    },
    "tags-overview": {
        "packagePath": "mosaic/tags/tags-overview",
        "title": "Basic tags",
        "componentName": "TagsOverviewExample",
        "files": [
            "tags-overview-example.ts",
            "tags-overview-example.html",
            "tags-overview-example.css"
        ],
        "selector": "tags-overview-example",
        "additionalComponents": [],
        "primaryFile": "tags-overview-example.ts",
        "module": {
            "name": "TagsExamplesModule",
            "importSpecifier": "mosaic/tags",
            "importPath": "ptsecurity-mosaic-examples-mosaic-tags"
        }
    },
    "text-area-overview": {
        "packagePath": "mosaic/textarea/text-area-overview",
        "title": "Basic textarea",
        "componentName": "TextAreaOverviewExample",
        "files": [
            "text-area-overview-example.ts",
            "text-area-overview-example.html",
            "text-area-overview-example.css"
        ],
        "selector": "text-area-overview-example",
        "additionalComponents": [],
        "primaryFile": "text-area-overview-example.ts",
        "module": {
            "name": "TextAreaExamplesModule",
            "importSpecifier": "mosaic/textarea",
            "importPath": "ptsecurity-mosaic-examples-mosaic-textarea"
        }
    },
    "timepicker-overview": {
        "packagePath": "mosaic/timepicker/timepicker-overview",
        "title": "Timepicker overview",
        "componentName": "TimepickerOverviewExample",
        "files": [
            "timepicker-overview-example.ts",
            "timepicker-overview-example.html",
            "timepicker-overview-example.css"
        ],
        "selector": "timepicker-overview-example",
        "additionalComponents": [],
        "primaryFile": "timepicker-overview-example.ts",
        "module": {
            "name": "TimepickerExamplesModule",
            "importSpecifier": "mosaic/timepicker",
            "importPath": "ptsecurity-mosaic-examples-mosaic-timepicker"
        }
    },
    "timepicker-range": {
        "packagePath": "mosaic/timepicker/timepicker-range",
        "title": "Timepicker range",
        "componentName": "TimepickerRangeExample",
        "files": [
            "timepicker-range-example.ts",
            "timepicker-range-example.html",
            "timepicker-range-example.css"
        ],
        "selector": "timepicker-range-example",
        "additionalComponents": [],
        "primaryFile": "timepicker-range-example.ts",
        "module": {
            "name": "TimepickerExamplesModule",
            "importSpecifier": "mosaic/timepicker",
            "importPath": "ptsecurity-mosaic-examples-mosaic-timepicker"
        }
    },
    "timepicker-validation-symbols": {
        "packagePath": "mosaic/timepicker/timepicker-validation-symbols",
        "title": "Timepicker overview",
        "componentName": "TimepickerValidationSymbolsExample",
        "files": [
            "timepicker-validation-symbols-example.ts",
            "timepicker-validation-symbols-example.html",
            "timepicker-validation-symbols-example.css"
        ],
        "selector": "timepicker-validation-symbols-example",
        "additionalComponents": [],
        "primaryFile": "timepicker-validation-symbols-example.ts",
        "module": {
            "name": "TimepickerExamplesModule",
            "importSpecifier": "mosaic/timepicker",
            "importPath": "ptsecurity-mosaic-examples-mosaic-timepicker"
        }
    },
    "timepicker-variations": {
        "packagePath": "mosaic/timepicker/timepicker-variations",
        "title": "Timepicker overview",
        "componentName": "TimepickerVariationsExample",
        "files": [
            "timepicker-variations-example.ts",
            "timepicker-variations-example.html",
            "timepicker-variations-example.css"
        ],
        "selector": "timepicker-variations-example",
        "additionalComponents": [],
        "primaryFile": "timepicker-variations-example.ts",
        "module": {
            "name": "TimepickerExamplesModule",
            "importSpecifier": "mosaic/timepicker",
            "importPath": "ptsecurity-mosaic-examples-mosaic-timepicker"
        }
    },
    "toggle-overview": {
        "packagePath": "mosaic/toggle/toggle-overview",
        "title": "Basic toggle",
        "componentName": "ToggleOverviewExample",
        "files": [
            "toggle-overview-example.ts",
            "toggle-overview-example.html",
            "toggle-overview-example.css"
        ],
        "selector": "toggle-overview-example",
        "additionalComponents": [],
        "primaryFile": "toggle-overview-example.ts",
        "module": {
            "name": "ToggleExamplesModule",
            "importSpecifier": "mosaic/toggle",
            "importPath": "ptsecurity-mosaic-examples-mosaic-toggle"
        }
    },
    "tooltip-overview": {
        "packagePath": "mosaic/tooltip/tooltip-overview",
        "title": "Basic tooltip",
        "componentName": "TooltipOverviewExample",
        "files": [
            "tooltip-overview-example.ts",
            "tooltip-overview-example.html",
            "tooltip-overview-example.css"
        ],
        "selector": "tooltip-overview-example",
        "additionalComponents": [],
        "primaryFile": "tooltip-overview-example.ts",
        "module": {
            "name": "TooltipExamplesModule",
            "importSpecifier": "mosaic/tooltip",
            "importPath": "ptsecurity-mosaic-examples-mosaic-tooltip"
        }
    },
    "tooltip-scrollable": {
        "packagePath": "mosaic/tooltip/tooltip-scrollable",
        "title": "Basic scrollable tooltip",
        "componentName": "TooltipScrollableExample",
        "files": [
            "tooltip-scrollable-example.ts",
            "tooltip-scrollable-example.html",
            "tooltip-scrollable-example.css"
        ],
        "selector": "tooltip-scrollable-example",
        "additionalComponents": [],
        "primaryFile": "tooltip-scrollable-example.ts",
        "module": {
            "name": "TooltipExamplesModule",
            "importSpecifier": "mosaic/tooltip",
            "importPath": "ptsecurity-mosaic-examples-mosaic-tooltip"
        }
    },
    "tree-select-child-selection-overview": {
        "packagePath": "mosaic/tree-select/tree-select-child-selection-overview",
        "title": "Basic Select",
        "componentName": "TreeSelectChildSelectionOverviewExample",
        "files": [
            "tree-select-child-selection-overview-example.ts",
            "tree-select-child-selection-overview-example.html",
            "tree-select-child-selection-overview-example.css"
        ],
        "selector": "tree-select-child-selection-overview-example",
        "additionalComponents": [],
        "primaryFile": "tree-select-child-selection-overview-example.ts",
        "module": {
            "name": "TreeSelectExamplesModule",
            "importSpecifier": "mosaic/tree-select",
            "importPath": "ptsecurity-mosaic-examples-mosaic-tree-select"
        }
    },
    "tree-select-footer-overview": {
        "packagePath": "mosaic/tree-select/tree-select-footer-overview",
        "title": "Tree select with footer",
        "componentName": "TreeSelectFooterOverviewExample",
        "files": [
            "tree-select-footer-overview-example.ts",
            "tree-select-footer-overview-example.html",
            "tree-select-footer-overview-example.css"
        ],
        "selector": "tree-select-footer-overview-example",
        "additionalComponents": [],
        "primaryFile": "tree-select-footer-overview-example.ts",
        "module": {
            "name": "TreeSelectExamplesModule",
            "importSpecifier": "mosaic/tree-select",
            "importPath": "ptsecurity-mosaic-examples-mosaic-tree-select"
        }
    },
    "tree-select-lazyload": {
        "packagePath": "mosaic/tree-select/tree-select-lazyload",
        "title": "Basic Select",
        "componentName": "TreeSelectLazyloadExample",
        "files": [
            "tree-select-lazyload-example.ts",
            "tree-select-lazyload-example.html",
            "tree-select-lazyload-example.css"
        ],
        "selector": "tree-select-lazyload-example",
        "additionalComponents": [],
        "primaryFile": "tree-select-lazyload-example.ts",
        "module": {
            "name": "TreeSelectExamplesModule",
            "importSpecifier": "mosaic/tree-select",
            "importPath": "ptsecurity-mosaic-examples-mosaic-tree-select"
        }
    },
    "tree-select-multiple-overview": {
        "packagePath": "mosaic/tree-select/tree-select-multiple-overview",
        "title": "Basic Select",
        "componentName": "TreeSelectMultipleOverviewExample",
        "files": [
            "tree-select-multiple-overview-example.ts",
            "tree-select-multiple-overview-example.html",
            "tree-select-multiple-overview-example.css"
        ],
        "selector": "tree-select-multiple-overview-example",
        "additionalComponents": [],
        "primaryFile": "tree-select-multiple-overview-example.ts",
        "module": {
            "name": "TreeSelectExamplesModule",
            "importSpecifier": "mosaic/tree-select",
            "importPath": "ptsecurity-mosaic-examples-mosaic-tree-select"
        }
    },
    "tree-select-overview": {
        "packagePath": "mosaic/tree-select/tree-select-overview",
        "title": "Basic Select",
        "componentName": "TreeSelectOverviewExample",
        "files": [
            "tree-select-overview-example.ts",
            "tree-select-overview-example.html",
            "tree-select-overview-example.css"
        ],
        "selector": "tree-select-overview-example",
        "additionalComponents": [],
        "primaryFile": "tree-select-overview-example.ts",
        "module": {
            "name": "TreeSelectExamplesModule",
            "importSpecifier": "mosaic/tree-select",
            "importPath": "ptsecurity-mosaic-examples-mosaic-tree-select"
        }
    },
    "tree-select-search-overview": {
        "packagePath": "mosaic/tree-select/tree-select-search-overview",
        "title": "Tree select search",
        "componentName": "TreeSelectSearchOverviewExample",
        "files": [
            "tree-select-search-overview-example.ts",
            "tree-select-search-overview-example.html",
            "tree-select-search-overview-example.css"
        ],
        "selector": "tree-select-search-overview-example",
        "additionalComponents": [],
        "primaryFile": "tree-select-search-overview-example.ts",
        "module": {
            "name": "TreeSelectExamplesModule",
            "importSpecifier": "mosaic/tree-select",
            "importPath": "ptsecurity-mosaic-examples-mosaic-tree-select"
        }
    },
    "tree-action-button": {
        "packagePath": "mosaic/tree/tree-action-button",
        "title": "Basic tree",
        "componentName": "TreeActionButtonExample",
        "files": [
            "tree-action-button-example.ts",
            "tree-action-button-example.html",
            "tree-action-button-example.css"
        ],
        "selector": "tree-action-button-example",
        "additionalComponents": [],
        "primaryFile": "tree-action-button-example.ts",
        "module": {
            "name": "TreeExamplesModule",
            "importSpecifier": "mosaic/tree",
            "importPath": "ptsecurity-mosaic-examples-mosaic-tree"
        }
    },
    "tree-filtering": {
        "packagePath": "mosaic/tree/tree-filtering",
        "title": "Basic tree",
        "componentName": "TreeFilteringExample",
        "files": [
            "tree-filtering-example.ts",
            "tree-filtering-example.html",
            "tree-filtering-example.css"
        ],
        "selector": "tree-filtering-example",
        "additionalComponents": [],
        "primaryFile": "tree-filtering-example.ts",
        "module": {
            "name": "TreeExamplesModule",
            "importSpecifier": "mosaic/tree",
            "importPath": "ptsecurity-mosaic-examples-mosaic-tree"
        }
    },
    "tree-lazyload": {
        "packagePath": "mosaic/tree/tree-lazyload",
        "title": "Basic tree",
        "componentName": "TreeLazyloadExample",
        "files": [
            "tree-lazyload-example.ts",
            "tree-lazyload-example.html",
            "tree-lazyload-example.css"
        ],
        "selector": "tree-lazyload-example",
        "additionalComponents": [],
        "primaryFile": "tree-lazyload-example.ts",
        "module": {
            "name": "TreeExamplesModule",
            "importSpecifier": "mosaic/tree",
            "importPath": "ptsecurity-mosaic-examples-mosaic-tree"
        }
    },
    "tree-multiple-checkbox": {
        "packagePath": "mosaic/tree/tree-multiple-checkbox",
        "title": "Basic tree",
        "componentName": "TreeMultipleCheckboxExample",
        "files": [
            "tree-multiple-checkbox-example.ts",
            "tree-multiple-checkbox-example.html",
            "tree-multiple-checkbox-example.css"
        ],
        "selector": "tree-multiple-checkbox-example",
        "additionalComponents": [],
        "primaryFile": "tree-multiple-checkbox-example.ts",
        "module": {
            "name": "TreeExamplesModule",
            "importSpecifier": "mosaic/tree",
            "importPath": "ptsecurity-mosaic-examples-mosaic-tree"
        }
    },
    "tree-multiple-checklist": {
        "packagePath": "mosaic/tree/tree-multiple-checklist",
        "title": "Checklist tree",
        "componentName": "TreeMultipleChecklistExample",
        "files": [
            "tree-multiple-checklist-example.ts",
            "tree-multiple-checklist-example.html",
            "tree-multiple-checklist-example.css"
        ],
        "selector": "tree-multiple-checklist-example",
        "additionalComponents": [],
        "primaryFile": "tree-multiple-checklist-example.ts",
        "module": {
            "name": "TreeExamplesModule",
            "importSpecifier": "mosaic/tree",
            "importPath": "ptsecurity-mosaic-examples-mosaic-tree"
        }
    },
    "tree-multiple-keyboard": {
        "packagePath": "mosaic/tree/tree-multiple-keyboard",
        "title": "Basic tree",
        "componentName": "TreeMultipleKeyboardExample",
        "files": [
            "tree-multiple-keyboard-example.ts",
            "tree-multiple-keyboard-example.html",
            "tree-multiple-keyboard-example.css"
        ],
        "selector": "tree-multiple-keyboard-example",
        "additionalComponents": [],
        "primaryFile": "tree-multiple-keyboard-example.ts",
        "module": {
            "name": "TreeExamplesModule",
            "importSpecifier": "mosaic/tree",
            "importPath": "ptsecurity-mosaic-examples-mosaic-tree"
        }
    },
    "tree-overview": {
        "packagePath": "mosaic/tree/tree-overview",
        "title": "Basic tree",
        "componentName": "TreeOverviewExample",
        "files": [
            "tree-overview-example.ts",
            "tree-overview-example.html",
            "tree-overview-example.css"
        ],
        "selector": "tree-overview-example",
        "additionalComponents": [],
        "primaryFile": "tree-overview-example.ts",
        "module": {
            "name": "TreeExamplesModule",
            "importSpecifier": "mosaic/tree",
            "importPath": "ptsecurity-mosaic-examples-mosaic-tree"
        }
    },
    "typography-overview": {
        "packagePath": "mosaic/typography/typography-overview",
        "title": "Basic typography",
        "componentName": "TypographyOverviewExample",
        "files": [
            "typography-overview-example.ts",
            "typography-overview-example.html",
            "typography-overview-example.css"
        ],
        "selector": "typography-overview-example",
        "additionalComponents": [],
        "primaryFile": "typography-overview-example.ts",
        "module": {
            "name": "TypographyExamplesModule",
            "importSpecifier": "mosaic/typography",
            "importPath": "ptsecurity-mosaic-examples-mosaic-typography"
        }
    },
    "validation-composite": {
        "packagePath": "mosaic/validation/validation-composite",
        "title": "validation-composite",
        "componentName": "ValidationCompositeExample",
        "files": [
            "validation-composite-example.ts",
            "validation-composite-example.html",
            "validation-composite-example.css"
        ],
        "selector": "validation-composite-example",
        "additionalComponents": [],
        "primaryFile": "validation-composite-example.ts",
        "module": {
            "name": "ValidationExamplesModule",
            "importSpecifier": "mosaic/validation",
            "importPath": "ptsecurity-mosaic-examples-mosaic-validation"
        }
    },
    "validation-global-one-required": {
        "packagePath": "mosaic/validation/validation-global-one-required",
        "title": "validation-global",
        "componentName": "ValidationGlobalOneRequiredExample",
        "files": [
            "validation-global-one-required-example.ts",
            "validation-global-one-required-example.html",
            "validation-global-one-required-example.css"
        ],
        "selector": "validation-global-one-required-example",
        "additionalComponents": [],
        "primaryFile": "validation-global-one-required-example.ts",
        "module": {
            "name": "ValidationExamplesModule",
            "importSpecifier": "mosaic/validation",
            "importPath": "ptsecurity-mosaic-examples-mosaic-validation"
        }
    },
    "validation-global": {
        "packagePath": "mosaic/validation/validation-global",
        "title": "validation-global",
        "componentName": "ValidationGlobalExample",
        "files": [
            "validation-global-example.ts",
            "validation-global-example.html",
            "validation-global-example.css"
        ],
        "selector": "validation-global-example",
        "additionalComponents": [],
        "primaryFile": "validation-global-example.ts",
        "module": {
            "name": "ValidationExamplesModule",
            "importSpecifier": "mosaic/validation",
            "importPath": "ptsecurity-mosaic-examples-mosaic-validation"
        }
    },
    "validation-on-blur": {
        "packagePath": "mosaic/validation/validation-on-blur",
        "title": "validation-on-blur",
        "componentName": "ValidationOnBlurExample",
        "files": [
            "validation-on-blur-example.ts",
            "validation-on-blur-example.html",
            "validation-on-blur-example.css"
        ],
        "selector": "validation-on-blur-example",
        "additionalComponents": [],
        "primaryFile": "validation-on-blur-example.ts",
        "module": {
            "name": "ValidationExamplesModule",
            "importSpecifier": "mosaic/validation",
            "importPath": "ptsecurity-mosaic-examples-mosaic-validation"
        }
    },
    "validation-on-type": {
        "packagePath": "mosaic/validation/validation-on-type",
        "title": "validation-on-type",
        "componentName": "ValidationOnTypeExample",
        "files": [
            "validation-on-type-example.ts",
            "validation-on-type-example.html",
            "validation-on-type-example.css"
        ],
        "selector": "validation-on-type-example",
        "additionalComponents": [],
        "primaryFile": "validation-on-type-example.ts",
        "module": {
            "name": "ValidationExamplesModule",
            "importSpecifier": "mosaic/validation",
            "importPath": "ptsecurity-mosaic-examples-mosaic-validation"
        }
    },
    "validation-overview": {
        "packagePath": "mosaic/validation/validation-overview",
        "title": "validation-overview",
        "componentName": "ValidationOverviewExample",
        "files": [
            "validation-overview-example.ts",
            "validation-overview-example.html",
            "validation-overview-example.css"
        ],
        "selector": "validation-overview-example",
        "additionalComponents": [],
        "primaryFile": "validation-overview-example.ts",
        "module": {
            "name": "ValidationExamplesModule",
            "importSpecifier": "mosaic/validation",
            "importPath": "ptsecurity-mosaic-examples-mosaic-validation"
        }
    },
    "validation-small": {
        "packagePath": "mosaic/validation/validation-small",
        "title": "validation-small",
        "componentName": "ValidationSmallExample",
        "files": [
            "validation-small-example.ts",
            "validation-small-example.html",
            "validation-small-example.css"
        ],
        "selector": "validation-small-example",
        "additionalComponents": [],
        "primaryFile": "validation-small-example.ts",
        "module": {
            "name": "ValidationExamplesModule",
            "importSpecifier": "mosaic/validation",
            "importPath": "ptsecurity-mosaic-examples-mosaic-validation"
        }
    }
};

// The example-module file will be auto-generated. As soon as the
/**
 * Example data with information about component name, selector, files used in
 * example, and path to examples.
 */
class ExampleData {
    constructor(example) {
        if (!example || !EXAMPLE_COMPONENTS.hasOwnProperty(example)) {
            return;
        }
        const { componentName, files, selector, primaryFile, additionalComponents, title } = EXAMPLE_COMPONENTS[example];
        const exampleName = example.replace(/(?:^\w|\b\w)/g, (letter) => letter.toUpperCase());
        this.exampleFiles = files;
        this.selectorName = selector;
        this.indexFilename = primaryFile;
        // tslint:disable-next-line:prefer-template
        this.description = title || exampleName.replace(/[\-]+/g, ' ') + ' Example';
        this.componentNames = [componentName, ...additionalComponents];
    }
}

/**
 * Generated bundle index. Do not edit.
 */

export { EXAMPLE_COMPONENTS, ExampleData };
